"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Caution = createSVGIconV2(
  <>
    <path
      d="M2.66127 20.5783L11.0933 2.44945C11.4519 1.67842 12.5481 1.67843 12.9067 2.44945L21.3387 20.5783C21.647 21.2411 21.1631 22 20.432 22H3.56799C2.83692 22 2.35296 21.2411 2.66127 20.5783Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10V16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19C13 18.7348 12.8946 18.4804 12.7071 18.2929C12.5196 18.1054 12.2652 18 12 18C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19Z"
      fill="currentColor"
    />
  </>,
  { displayName: "Caution", scalingFactor: 139 / 128 },
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
